const initialState = {
    Event_Question_Table_data: {
      columns : [
        // {
        //   label: "Title",
        //   field: 'title',
        //   sort: 'asc'
        // },
        {
          label: 'Question',
          field: 'description',
          sort: 'asc'
        },
        {
          label: 'Status',
          field: 'status',
          sort: 'asc'
        },
        {
          label: 'Action',
          field: 'action',
          sort: 'asc',
          width: 100,
          searchable: true,
          className:"action-org-test"
        }
      ]
    }
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
      default:
        return state;
    }
  };

export default reducer;
